(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pgx-hide-mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const marketplace = document.querySelector('.pgx-marketplace');
    const intro = marketplace?.querySelector('.pgx-marketplace__intro');

    if (marketplace && intro && !marketplace.querySelector('.pgx-brand-code')) {
      const brandCode = document.createElement('div');
      brandCode.className = 'pgx-brand-code';
      brandCode.setAttribute('aria-label', 'PGX');
      brandCode.innerHTML = '<span class="pgx-brand-code__mark">PGX</span>';
      intro.insertAdjacentElement('afterend', brandCode);

      const trust = document.createElement('div');
      trust.className = 'pgx-market-trust';
      trust.setAttribute('aria-label', 'Shopping benefits');
      ['Sold as a pair', 'Easy size exchanges', 'Secure checkout'].forEach((text) => {
        const item = document.createElement('span');
        item.textContent = text;
        trust.appendChild(item);
      });
      brandCode.insertAdjacentElement('afterend', trust);
    }

    const apparelLink = marketplace?.querySelector('a[href*="/collections/swag-accessories"]');
    apparelLink?.closest('.pgx-marketplace__group')?.remove();

    const comingGroup = marketplace?.querySelector('.pgx-marketplace__group--coming');

    marketplace?.querySelectorAll('.pgx-marketplace__group:not(.pgx-marketplace__group--coming) .pgx-market-card').forEach((card) => {
      const media = card.querySelector('.pgx-market-card__media');
      if (!media || media.querySelector('.pgx-pair-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'pgx-pair-badge';
      badge.textContent = 'Sold as a pair';
      media.appendChild(badge);
    });

    if (window.location.hash.startsWith('#pgx-notify-') && new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      const success = document.createElement('p');
      success.className = 'pgx-notify-success';
      success.setAttribute('role', 'status');
      success.textContent = 'You’re on the PGX launch list. Watch your inbox for the new drop.';
      comingGroup?.insertAdjacentElement('afterbegin', success);
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    comingGroup?.querySelectorAll('.pgx-market-card').forEach((card, index) => {
      const detailsLink = card.querySelector('.pgx-market-card__details');
      const productLink = card.querySelector('h3 a');
      if (!detailsLink || !productLink) return;

      const productTitle = productLink.textContent.trim();
      const form = document.createElement('form');
      form.className = 'pgx-notify-form';
      form.method = 'post';
      form.action = `/contact#pgx-notify-${index}`;
      form.id = `pgx-notify-${index}`;
      const label = document.createElement('p');
      label.className = 'pgx-notify-form__label';
      label.textContent = `Get notified when ${productTitle} launches.`;

      const formType = document.createElement('input');
      formType.type = 'hidden';
      formType.name = 'form_type';
      formType.value = 'customer';

      const tags = document.createElement('input');
      tags.type = 'hidden';
      tags.name = 'contact[tags]';
      tags.value = `coming-soon, notify-me, ${productTitle}`;

      const email = document.createElement('input');
      email.type = 'email';
      email.name = 'contact[email]';
      email.autocomplete = 'email';
      email.placeholder = 'Email address';
      email.setAttribute('aria-label', `Email address for ${productTitle} launch updates`);
      email.required = true;

      const button = document.createElement('button');
      button.type = 'submit';
      button.textContent = 'Notify me';

      form.append(label, formType, tags, email, button);
      detailsLink.replaceWith(form);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
